import { gql } from '@apollo/client';

export const GET_ALL_SUBSCRIPTION_PACKAGES = gql`
  query GetAllSubscriptionPackages($filter: SubscriptionPackageFilterInput) {
    getAllSubscriptionPackages(filter: $filter) {
      id
      name
      description
      duration
      price
    }
  }
`;

export const GET_SUBSCRIPTION_PACKAGE_BY_ID = gql`
  query GetSubscriptionPackageById($getSubscriptionPackageByIdId: ID!) {
    getSubscriptionPackageById(id: $getSubscriptionPackageByIdId) {
      id
      name
      description
      duration
      price
    }
  }
`;

export const CREATE_SUBSCRIPTION_PACKAGE = gql`
  mutation CreateSubscriptionPackage($input: SubscriptionPackageCreateInput!) {
    createSubscriptionPackage(input: $input) {
      id
      name
      description
      duration
      price
    }
  }
`;

export const UPDATE_SUBSCRIPTION_PACKAGE = gql`
  mutation UpdateSubscriptionPackage($input: SubscriptionPackageUpdateInput!, $updateSubscriptionPackageId: ID!) {
    updateSubscriptionPackage(input: $input, id: $updateSubscriptionPackageId) {
      id
      name
      duration
      price
      description
    }
  }
`;

export const DELETE_SUBSCRIPTION_PACKAGE = gql`
  mutation DeleteSubscriptionPackage($deleteSubscriptionPackageId: ID!) {
    deleteSubscriptionPackage(id: $deleteSubscriptionPackageId)
  }
`;
